import React from 'react'
import css from './style.scss'
import {PopupPage} from 'components/container'
import store from 'utils/store'
import Button from 'components/shared/button'
import {CopyToClipboard} from 'react-copy-to-clipboard';

const copy=()=>{
  store.dispatch({type:"ADD_TOAST", message:"URL copied, go share it with your friends!"})
}

class ShareModal extends React.Component{
  render(){
    const shareURL=process.env.REACT_APP_URL + "/c/"+this.props.uuid
    return (
      <PopupPage backTo={this.props.onClose} width="small" onTop>
        <div className={css.share}>
          <h3>Share your adventure</h3>
          <p>Anyone with this link can view this adventure and its stats, so <b>share it wisely</b>.</p>
          <div className={css.linkContainer}>
            <a target="_blank" className={css.link} href={shareURL}>{shareURL}</a>
            <CopyToClipboard text={shareURL}
              onCopy={copy}>
              <Button small primary>Copy URL</Button>
            </CopyToClipboard>
          </div>
        </div>
      </PopupPage>
    )
  }

}

export default ShareModal



// WEBPACK FOOTER //
// ./src/components/account_page/adventures/adventure_page/shareModal.js